export default {
  name: 'tnf-prod',
  appId: 'wx2fe3641997529366',
  wechatId: '211'
};